export default __webpack_public_path__ + "static/9-c42bb767ab9ba0627373caeb06c192d2.webp";